/**
 * Utility function to get the appropriate Material-UI icon name for each asset type
 * @param assetType The asset type string value
 * @returns The Material-UI icon name
 */
export function getAssetTypeIcon(assetType: string): string {
  // Default icon
  if (!assetType) return 'house';

  // Convert to lowercase and replace spaces with underscores for comparison
  const normalizedType = assetType.toLowerCase().replace(/\s+/g, '_');

  // Map of asset types to Material-UI icon names
  switch (normalizedType) {
    case 'transmission_line':
      return 'electric_bolt';
    case 'power_station':
      return 'power';
    case 'transmission_substation':
      return 'electric_bolt';
    case 'wind_turbine':
      return 'wind_power';
    case 'building':
      return 'apartment';
    case 'highway':
      return 'directions_car';
    case 'road':
      return 'add_road';
    default:
      return 'category'; // Default for "Other" or unknown types
  }
}

/**
 * Get both icon name and a user-friendly display name for the asset type
 * @param assetType The asset type string value
 * @returns Object containing icon name and display name
 */
export function getAssetTypeDisplay(assetType: string): { iconName: string; displayName: string } {
  return {
    iconName: getAssetTypeIcon(assetType),
    displayName: assetType || 'Unknown'
  };
}
